import LayerGroup from "ol/layer/Group"; // Importamos LayerGroup
import Map from "ol/Map";
import View from "ol/View";
import { getTopLeft } from "ol/extent";
import { get } from "ol/proj";
import { TileGrid } from "ol/tilegrid";
import { get_default_base_map } from "./BaseMapsService";
import { Feature } from "ol";
import { VectorImage, Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { z_index_values } from "../Commons/zIndexService";
import { get_default_controls } from "./MapControlsService";
import { Point, LineString, Polygon } from "ol/geom";
import { Style, Icon, Stroke, Fill, Circle as CircleStyle } from "ol/style";
import { toast } from "react-toastify";

import Transform from "ol-ext/interaction/Transform";
import * as condition from "ol/events/condition"; // Para los eventos (shift, ctrl, etc.)
import { GeoJSON } from "ol/format";

import SnapGuides from "ol-ext/interaction/SnapGuides";
import Draw from "ol/interaction/Draw";
import { defaults as defaultInteractions } from "ol/interaction";
import ModifyFeature from "ol-ext/interaction/ModifyFeature";

import CircleGeom from "ol/geom/Circle";

// Función para crear un marcador
export const createMarker = (coordinate) => {
  return new Feature({
    geometry: new Point(coordinate),
  });
};

// Función para crear una capa de marcadores (si no existe)
export const createMarkerLayer = () => {
  return new VectorLayer({
    zIndex: z_index_values["default_point_marker"],
    source: new VectorSource(),
    style: new Style({
      image: new Icon({
        src: process.env.PUBLIC_URL + "images/icons/map-pin-icon.svg", //"/images/marker.png",
        //src: process.env.PUBLIC_URL + "/images/marker.png",
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 0.08, // 0.04

        //scale: 0.04
      }),
    }),
  });
};

const add_mouse_click_event = (map, click_callback) => {
  console.log("Añadiendo evento de click en mapa.", map);
  let markerLayer = map
    .getLayers()
    .getArray()
    .find((layer) => layer.get("name") === "markerLayer");
  if (!markerLayer) {
    markerLayer = createMarkerLayer();
    markerLayer.set("name", "markerLayer");
    markerLayer.setZIndex(9999); // Asegurar que está sobre todas las capas

    map.addLayer(markerLayer);
  }

  map.on("dblclick", click_callback);
};

const add_visualization_layers_to_map = (map, layerGroups) => {
  // Iterar sobre las layersGroups para crear LayerGroups
  layerGroups.forEach((layerGroup) => {
    const { visible, opacity, order, layers, name, id } = layerGroup;
    // Crear el LayerGroup para cada visualización
    // console.log("Creando LayerGroup", layerGroup);
    const new_layerGroup = new LayerGroup({
      visible: visible,
      opacity: opacity,
      zIndex: 1000 - order,
      // layers: layers.map(({ layer, id, name, opacity, visible, zIndex }) => {
      //   if (layer) {
      //     Object.assign(layer, { id, name, opacity, visible, zIndex });
      //   }
      //   return layer;
      // }),
      layers: layers.map((layerConfig) => {
        // console.log("Creando capa", layerConfig);
        const { layer, name, id, opacity, visible, zIndex } = layerConfig;
        // Asignamos un id único a cada capa antes de agregarla al LayerGroup
        layer?.set("id", id);
        layer?.set("name", name);
        layer?.set("opacity", opacity);
        layer?.set("visible", visible);
        layer?.set("zIndex", zIndex);

        // console.log("tileLayer", tileLayer);
        return layer;
      }),
    });
    new_layerGroup.set("id", id); // Asignar el id del grupo
    new_layerGroup.set("name", name); // Asignar el nombre del grupo
    // console.log("new_layerGroup", new_layerGroup);
    map.addLayer(new_layerGroup); // Añadir el LayerGroup al mapa
    // console.log("new_layerGroup ADDED", new_layerGroup);
  });
};

const get_initial_map = (
  mapElementRef,
  center = [-3.70256, 40.4165],
  zoom = 7
) => {
  const baseMapLayer = get_default_base_map();
  const controls = get_default_controls();
  const initialMap = new Map({
    interactions: defaultInteractions({ doubleClickZoom: false }),

    target: mapElementRef.current,
    layers: [baseMapLayer], // Inicialmente solo el mapa base
    view: new View({
      projection: "EPSG:4326",
      center: center,
      zoom: zoom,
    }),
    controls: controls,
  });
  // console.log("Mapa inicial", initialMap);
  //mapElementRef.current = initialMap
  return initialMap;
};

const get_epsg4326_projection_data_to_source = () => {
  var projection = get("EPSG:4326");
  var projectionExtent = projection.getExtent();
  var matrixIds = new Array(22);
  const tileGrid4326 = new TileGrid({
    origin: getTopLeft(projectionExtent),
    resolutions: [
      0.703125, 0.3515625, 0.17578125, 0.087890625, 0.0439453125, 0.02197265625,
      0.010986328125, 0.0054931640625, 0.00274658203125, 0.001373291015625,
      0.0006866455078125, 0.00034332275390625, 0.000171661376953125,
      0.0000858306884765625, 0.00004291534423828125, 0.000021457672119140625,
      0.000010728836059570313, 0.000005364418029785156, 0.000002682209014892578,
      0.000001341104507446289, 0.0000006705522537231445,
      0.00000033527612686157227,
    ],
    matrixIds: matrixIds,
  });
  return {
    projection,
    projectionExtent,
    matrixIds,
    tileGrid4326,
  };
};

/**
 * Función para agregar una capa con la geometría del feature al mapa
 * @param {Object} map - Instancia del mapa
 * @param {Object} geometry - Geometría del feature
 */
const addFeatureLayerToMap = (map, geometry, setEditedGeometry) => {
  // Elimina capas anteriores de resaltado si existen
  const existingLayers = map.getLayers().getArray();
  const highlightLayer = existingLayers.find(
    (layer) => layer.get("name") === "highlightLayer"
  );
  if (highlightLayer) {
    map.removeLayer(highlightLayer);
  }

  // Crear la fuente vectorial y la capa
  const vectorSource = new VectorSource();
  const createHatchPattern = () => {
    const canvas = document.createElement("canvas");
    canvas.width = 10;
    canvas.height = 10;
    const ctx = canvas.getContext("2d");

    // Dibujar líneas diagonales
    ctx.strokeStyle = "rgba(0, 0,255)"; // Color rojo con algo de transparencia
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(0, 10);
    ctx.lineTo(10, 0);
    ctx.stroke();

    return ctx.createPattern(canvas, "repeat");
  };

  const vectorLayer = new VectorLayer({
    source: vectorSource,
    style: new Style({
      stroke: new Stroke({
        color: "blue",
        width: 5, // Borde más grueso
      }),
      fill: new Fill({
        color: createHatchPattern(), // Relleno con patrón de líneas
      }),
      image: new CircleStyle({
        radius: 8, // Círculo más grande
        fill: new Fill({ color: "green" }),
        stroke: new Stroke({ color: "white", width: 3 }), // Borde blanco más grueso
      }),
    }),
  });

  vectorLayer.set("name", "highlightLayer"); // Nombramos la capa para futuras referencias
  vectorLayer.setZIndex(90); // Asegurar que está sobre todas las capas

  // Convertir la geometría al formato de OpenLayers
  let featureGeometry;
  switch (geometry.type) {
    case "Point":
      featureGeometry = new Point(geometry.coordinates);
      break;
    case "LineString":
      featureGeometry = new LineString(geometry.coordinates);
      break;
    case "Polygon":
      featureGeometry = new Polygon(geometry.coordinates);
      break;
    default:
      console.warn("Tipo de geometría no soportado:", geometry.type);
      return;
  }

  // Crear el feature y añadirlo a la capa
  const feature = new Feature({
    geometry: featureGeometry,
  });
  vectorSource.addFeature(feature);
  map.addLayer(vectorLayer);
  // Eliminar interacciones previas
  const interactions = map.getInteractions().getArray();
  const existingTransform = interactions.find(
    (interaction) => interaction instanceof Transform
  );
  if (existingTransform) {
    map.removeInteraction(existingTransform);
  }

  // Crear la nueva interacción de transformación
  const transformInteraction = new Transform({
    enableRotatedTransform: true, // Permitir transformaciones rotadas
    translateFeature: true, // Permitir mover el feature
    scale: true, // Permitir escalar
    rotate: true, // Permitir rotar
    keepAspectRatio: condition.always, // Mantener proporción al escalar
    stretch: true, // Permitir estirar en ejes independientes
    layers: [
      map
        .getLayers()
        .getArray()
        .find((l) => l.get("name") === "highlightLayer"),
    ],
  });

  map.addInteraction(transformInteraction);

  // Seleccionar automáticamente el feature para su transformación
  transformInteraction.select(feature);

  // Escuchar eventos de transformación para capturar la geometría editada
  transformInteraction.on(["rotating", "scaling", "translating"], (event) => {
    const editedFeature = event.features.item(0);
    const editedGeometry = editedFeature.getGeometry();
    console.log("Nueva geometría editada:", editedGeometry);
  });

  // Evento cuando finaliza la edición
  transformInteraction.on(
    ["rotateend", "scaleend", "translateend"],
    (event) => {
      const editedFeature = event.features.item(0);
      const editedGeometry = editedFeature.getGeometry();
      // Convertir a GeoJSON sin modificar la proyección si ya es EPSG:4326
      const geojsonFormat = new GeoJSON();
      const geojsonFeature = {
        type: "Feature",
        geometry: geojsonFormat.writeGeometryObject(
          editedGeometry, // Asegurar que está en EPSG:4326
          { dataProjection: "EPSG:4326", featureProjection: "EPSG:4326" }
        ),
        properties: {}, // Puedes agregar propiedades aquí si es necesario
      };
      // const geojsonFeature = geojsonFormat.writeGeometryObject(editedGeometry, {
      //   dataProjection: "EPSG:4326", // GeoJSON siempre en WGS84
      //   featureProjection: "EPSG:4326",
      // });
      console.log("GEOJSON", geojsonFeature);

      // Guardar la geometría editada en el estado (opcional)
      if (setEditedGeometry) {
        setEditedGeometry(geojsonFeature);
      }
    }
  );

  return vectorLayer;
};

// Crear la fuente vectorial compartida
const vectorSource = new VectorSource();
const vectorLayer = new VectorLayer({
  source: vectorSource,
  style: new Style({
    stroke: new Stroke({
      color: "blue",
      width: 2,
    }),
    fill: new Fill({
      color: "rgba(0, 0, 255, 0.1)",
    }),
  }),
});

let snap;
/**
 * Función para agregar una capa con la geometría del feature al mapa
 * @param {Object} map - Instancia del mapa
 * @param {Object} layer - Capa sobre la que se dibujará
 * @param {Function} setEditedGeometry - Función para actualizar la geometría editada
 */
const createNewFeatureLayerToMap = ({ map, layer, setEditedGeometry }) => {
  if (!map.getLayers().getArray().includes(vectorLayer)) {
    console.log("ADD LAYER");
    vectorLayer.setZIndex(999);
    map.addLayer(vectorLayer);
  } else console.log("NOT ADD LAYER");

  console.log("Habilitando edición para la capa:", layer);

  const draw = new Draw({
    source: vectorSource,
    type: "Polygon",
    // type: "MultiPolygon",
  });
  map.addInteraction(draw);

  // let snap;

  if (localStorage.getItem("enableSnapGuides") === "true") {
    snap = new SnapGuides({
      vectorClass: VectorImage,
    });

    // Configurar snapping solo con la geometría ajustada
    snap.setDrawInteraction(draw);
    map.addInteraction(snap);
  }

  // Capturar la finalización del dibujo evitando la duplicación de puntos
  draw.on("drawend", function (event) {
    const feature = event.feature;

    console.log("Polígono dibujado:", feature.getGeometry().getCoordinates());

    // ⚠️ Guardar solo la versión ajustada por SnapGuides
    setEditedGeometry((prev) => [
      ...(Array.isArray(prev) ? prev : []), // Si prev no es un array, lo inicializa como []
      ...feature.getGeometry().getCoordinates(),
    ]);

    // Refrescar la capa
    vectorSource.changed();
  });

  // Usar ModifyFeature en lugar de Modify estándar
  const modifyFeature = new ModifyFeature({ source: vectorSource });

  map.addInteraction(modifyFeature);

  // Capturar modificaciones en la geometría
  modifyFeature.on("modifyend", function (event) {
    console.log("modifyend", event);
    const modifiedFeatures = event.features;

    if (modifiedFeatures.length > 0) {
      // Obtener la geometría del polígono modificado
      const modifiedGeometry = modifiedFeatures[0]
        .getGeometry()
        .getCoordinates()[0];
      console.log("Polígono modificado editedGeometry:", modifiedGeometry);

      setEditedGeometry((prev) => {
        const existingPolygons = Array.isArray(prev) ? prev : [];

        // Buscar cuál de los polígonos en prev ha sido modificado
        const updatedPolygons = existingPolygons.map((polygon) => {
          console.log(
            "isSamePolygon editedgeometry",
            polygon,
            modifiedGeometry,
            isSamePolygon(polygon, modifiedGeometry)
          );
          return isSamePolygon(polygon, modifiedGeometry)
            ? modifiedGeometry
            : polygon;
        });
        console.log("setEditedGeometry:", modifiedGeometry, updatedPolygons);

        return updatedPolygons;
      });

      vectorSource.changed();
    }
  });

  // Si pulsas el escape, se elimina lo que lleves dibujado
  document.addEventListener("keydown", (e) => {
    console.log("TECLA presionado");
    if (e.key === "Escape" && draw) {
      console.log("ESC presionado: cancelando dibujo");

      // Cancelar dibujo
      draw.abortDrawing();

      // Limpiar geometría temporal
      vectorSource.clear();
      if (snap) snap.clearGuides();

      // Opcional: resetear estado externo
      if (typeof setEditedGeometry === "function") {
        setEditedGeometry(null);
      }
    }
  });

  /**
   * Función para comparar si dos polígonos son iguales (para detectar cuál fue modificado)
   * @param {Array} poly1 - Coordenadas del polígono 1
   * @param {Array} poly2 - Coordenadas del polígono 2
   * @returns {boolean} - True si son el mismo polígono
   */
  function isSamePolygon(poly1, poly2) {
    if (!Array.isArray(poly1) || !Array.isArray(poly2)) return false;

    // Caso 1: misma longitud → 1 punto modificado
    if (poly1.length === poly2.length) {
      let differences = 0;

      for (let i = 0; i < poly1.length; i++) {
        const [x1, y1] = poly1[i];
        const [x2, y2] = poly2[i];

        if (x1 !== x2 || y1 !== y2) differences++;
        if (differences > 1) return false; // más de 1 punto cambiado
      }

      return differences === 1;
    }

    // Caso 2: poly2 tiene un punto más → se ha añadido un vértice
    if (poly2.length === poly1.length + 1) {
      // Buscamos una única posición donde al eliminar ese punto extra, los arrays coincidan
      for (let i = 0; i < poly2.length; i++) {
        const poly2Clone = poly2.slice(0, i).concat(poly2.slice(i + 1));
        if (arraysEqual(poly1, poly2Clone)) return true;
      }

      return false;
    }

    return false; // Cualquier otro caso no es una modificación válida
  }

  function arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((point, i) => point[0] === b[i][0] && point[1] === b[i][1]);
  }
};

/**
 * Función para salir del modo de edición
 * @param {Object} map - Instancia del mapa
 */
const exitEditMode = ({ map }) => {
  console.log("Saliendo del modo de edición...");

  // Buscar y eliminar interacciones específicas
  const interactionsToRemove = map
    .getInteractions()
    .getArray()
    .filter(
      (interaction) =>
        interaction instanceof Draw ||
        interaction instanceof ModifyFeature ||
        interaction instanceof SnapGuides ||
        interaction instanceof Transform
    );

  interactionsToRemove.forEach((interaction) => {
    if (interaction instanceof SnapGuides) {
      console.log("Desactivando y eliminando SnapGuides...", interaction);

      interaction.clearGuides(); // Apagar SnapGuides antes de eliminar
    }
    map.removeInteraction(interaction);
  });

  // Limpiar la fuente de datos para eliminar geometrías previas
  if (vectorSource) {
    vectorSource.clear();
    console.log("Geometrías eliminadas de la capa de edición.");
  }

  // Eliminar la capa de edición del mapa
  if (map.getLayers().getArray().includes(vectorLayer)) {
    map.removeLayer(vectorLayer);
    console.log("Capa de edición eliminada.");
  }

  console.log("Modo de edición desactivado.");
};

const removeHighlightLayerFromMap = (map) => {
  console.log("Buscando y eliminando la capa de resaltado...");

  // Obtener todas las capas del mapa
  const existingLayers = map.getLayers().getArray();

  // Buscar la capa con el nombre "highlightLayer"
  const highlightLayer = existingLayers.find(
    (layer) => layer.get("name") === "highlightLayer"
  );

  // Si la capa existe, eliminarla del mapa
  if (highlightLayer) {
    map.removeLayer(highlightLayer);
    console.log("Capa de resaltado eliminada.");
  } else {
    console.log("No se encontró la capa de resaltado.");
  }
};

function resetRotation({ map }) {
  if (!map) return;

  map.getView().animate({
    rotation: 0, // Establece la rotación a 0
    duration: 1000, // Duración de la animación en milisegundos (1s)
  });
}

// Reutilizamos el vectorSource y vectorLayer
const singleEditSource = new VectorSource();
const singleEditLayer = new VectorImage({
  source: singleEditSource,
  style: new Style({
    stroke: new Stroke({ color: "blue", width: 2 }),
    fill: new Fill({ color: "rgba(0, 0, 255, 0.1)" }),
  }),
});
singleEditLayer.setZIndex(999);

/**
 * Crea el modo de edición de un solo polígono con snapping habilitado.
 * @param {Object} params
 * @param {Object} params.map - Instancia del mapa
 * @param {Function} params.setEditedGeometry - Setter para guardar la geometría editada
 */
function createSinglePolygonEditMode({ map, setEditedGeometry }) {
  // Añadir la capa al mapa si no está
  if (!map.getLayers().getArray().includes(singleEditLayer)) {
    map.addLayer(singleEditLayer);
  }

  // Crear Draw interaction
  const draw = new Draw({
    source: singleEditSource,
    type: "Polygon",
  });

  // Crear SnapGuides con VectorImage
  const snap = new SnapGuides({ vectorClass: VectorImage });
  snap.setDrawInteraction(draw);
  map.addInteraction(snap);

  // Crear ModifyFeature
  const modify = new ModifyFeature({ source: singleEditSource });

  // Limpiar la geometría anterior al iniciar un nuevo dibujo
  draw.on("drawstart", () => {
    singleEditSource.clear();
  });

  // Al finalizar el dibujo
  draw.on("drawend", (event) => {
    const feature = event.feature;

    const geometry = feature.getGeometry();
    setEditedGeometry(geometry.getCoordinates());
  });
  map.addInteraction(draw);

  // Capturar modificaciones
  modify.on("modifyend", (event) => {
    if (event.features && event.features.length > 0) {
      const feature = event.features[0];
      const geometry = feature.getGeometry();
      setEditedGeometry(geometry.getCoordinates());
    }
  });
  map.addInteraction(modify);

  // Para evitar que funcione el click derecho
  map.on("pointerdown", (evt) => {
    if (evt.originalEvent.button !== 0) {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  });

  // Si pulsas el escape, se elimina lo que lleves dibujado
  document.addEventListener("keydown", (e) => {
    console.log("TECLA presionado");
    if (e.key === "Escape" && draw) {
      console.log("ESC presionado: cancelando dibujo");

      // Cancelar dibujo
      draw.abortDrawing();

      // Limpiar geometría temporal
      vectorSource.clear();
      snap.clearGuides();

      // Opcional: resetear estado externo
      if (typeof setEditedGeometry === "function") {
        setEditedGeometry(null);
      }
    }
  });
}

/**
 * Resetea todos los dibujos actuales y las guías de snap, pero sin eliminar interacciones ni capas.
 * Útil para reiniciar el proceso de dibujo sin salir del modo de edición.
 * @param {Object} options
 * @param {ol.Map} options.map - Instancia del mapa
 * @param {Function} [options.setEditedGeometry] - Setter para reiniciar geometría editada
 */
function resetDrawingSession({ map, setEditedGeometry }) {
  console.log("Reseteando sesión de dibujo...");

  // Limpiar geometrías de todas las fuentes de edición conocidas
  if (vectorSource && typeof vectorSource.clear === "function") {
    vectorSource.clear();
  }
  if (singleEditSource && typeof singleEditSource.clear === "function") {
    singleEditSource.clear();
  }

  // Buscar y limpiar SnapGuides activos
  const snapGuide = map
    .getInteractions()
    .getArray()
    .find((i) => i instanceof SnapGuides);

  if (snapGuide) {
    console.log("Limpiando SnapGuides...");
    snapGuide.clearGuides();
  }

  // Reiniciar estado de geometría editada si se proporciona
  if (typeof setEditedGeometry === "function") {
    setEditedGeometry(null);
  }

  console.log("Sesión de dibujo reiniciada.");
}

/**
 * Alterna la activación de SnapGuides en el mapa
 * @param {Object} map - Instancia del mapa
 */
const toggleSnapGuides = (map) => {
  const snapInstance = map
    .getInteractions()
    .getArray()
    .find((i) => i instanceof SnapGuides);

  if (snapInstance) {
    map.removeInteraction(snapInstance);
    console.log("SnapGuides DESACTIVADO");
  } else {
    const draw =
      map
        .getInteractions()
        .getArray()
        .find((i) => i instanceof Draw) || null;

    // const snap = new SnapGuides({ vectorClass: VectorImage });
    snap = new SnapGuides({ vectorClass: VectorImage });
    snap.setDrawInteraction(draw);
    map.addInteraction(snap);

    console.log("SnapGuides ACTIVADO");
  }
};

/** Returns existing user location layer or creates one if missing */
function getOrCreateUserLocationLayer(map) {
  const existing = map
    .getLayers()
    .getArray()
    .find((l) => l.get("name") === "userLocationLayer");
  if (existing) return existing;

  const source = new VectorSource();

  const layer = new VectorLayer({
    source,
    zIndex: 10000,
    style: (feat) => {
      // Style accuracy circle
      if (feat.get("kind") === "accuracy") {
        return new Style({
          fill: new Fill({ color: "rgba(33,150,243,0.15)" }),
          stroke: new Stroke({ color: "rgba(33,150,243,0.6)", width: 1 }),
        });
      }
      // Style position point
      return new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({ color: "#2196f3" }),
          stroke: new Stroke({ color: "#ffffff", width: 2 }),
        }),
      });
    },
  });

  layer.set("name", "userLocationLayer");
  map.addLayer(layer);
  return layer;
}

function showUserLocation(
  map,
  opts = { follow: true, showAccuracy: true, firstFixTimeout: 8000 },
  onEvent
) {
  // Let the UI know we started asking for location
  onEvent && onEvent({ type: "requesting" });

  const layer = getOrCreateUserLocationLayer(map);
  const source = layer.getSource();

  const posFeature = new Feature({ kind: "position" });
  const accFeature = new Feature({ kind: "accuracy" });
  if (!source.getFeatures().includes(posFeature)) source.addFeature(posFeature);
  if (opts.showAccuracy && !source.getFeatures().includes(accFeature))
    source.addFeature(accFeature);

  let firstFixDone = false;

  const applyPosition = (pos) => {
    const lon = pos.coords.longitude;
    const lat = pos.coords.latitude;

    // Update point
    posFeature.setGeometry(new Point([lon, lat]));

    // Accuracy circle: meters -> degrees (EPSG:4326)
    if (opts.showAccuracy) {
      const meters = pos.coords.accuracy || 0;
      const metersPerDegLat = 111320; // approx
      const radiusDeg = meters / metersPerDegLat;
      accFeature.setGeometry(new CircleGeom([lon, lat], radiusDeg));
    }

    if (!firstFixDone) {
      firstFixDone = true;
      if (opts.follow) {
        const view = map.getView();
        const currentZoom = view.getZoom() || 7;
        view.animate({
          center: [lon, lat],
          zoom: Math.max(currentZoom, 14),
          duration: 600,
        });
      }
      onEvent && onEvent({ type: "ready", coords: { lon, lat } });
    } else {
      onEvent && onEvent({ type: "update", coords: { lon, lat } });
    }
  };

  const onError = (err) => {
    console.error("Geolocation error:", err);
    onEvent && onEvent({ type: "error", error: err });
  };

  // Quick first fix attempt
  const firstFixTimeout = opts.firstFixTimeout || 8000;
  try {
    navigator.geolocation.getCurrentPosition(applyPosition, onError, {
      enableHighAccuracy: true,
      timeout: firstFixTimeout,
      maximumAge: 0,
    });
  } catch (_) {}

  // Continuous updates (and fallback for first fix)
  const watchId = navigator.geolocation.watchPosition(applyPosition, onError, {
    enableHighAccuracy: true,
    maximumAge: 10000,
    timeout: 20000,
  });

  return {
    stop: () => {
      try {
        navigator.geolocation.clearWatch(watchId);
      } catch (_) {}
    },
    isReady: () => firstFixDone,
  };
}

/** Recenters the view on the latest known user position, if available */
function recenterOnUser(map) {
  const layer = getOrCreateUserLocationLayer(map);
  const source = layer.getSource();
  const pos = source.getFeatures().find((f) => f.get("kind") === "position");
  if (!pos || !pos.getGeometry()) return;
  const [lon, lat] = pos.getGeometry().getCoordinates();
  map.getView().animate({ center: [lon, lat], duration: 400 });
}

async function requestOrExplainGeolocation(map) {
  // NOTE: Permissions API is not supported everywhere; code handles fallback.
  try {
    // @ts-expect-error: Permissions API typing may be partial
    const status = await navigator.permissions?.query({ name: "geolocation" });
    const state = status?.state;

    // @ts-expect-error - not all browsers implement onchange
    if (status && typeof status.onchange === "object") {
      // Optional: listen to permission changes and react accordingly
      status.onchange = () => {
        // console.log("Geolocation permission changed:", status.state);
      };
    }

    if (state === "granted") {
      recenterOnUser(map);
      return;
    }

    if (state === "prompt" || !state) {
      // Calling getCurrentPosition on a user gesture should trigger the prompt
      await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            // Success path: center and (optionally) start watcher elsewhere
            const [lon, lat] = [pos.coords.longitude, pos.coords.latitude];
            map.getView().animate({
              center: [lon, lat],
              zoom: Math.max(map.getView().getZoom() || 7, 14),
              duration: 600,
            });
            resolve();
          },
          (err) => {
            // If the user cancels or denies here, explain next steps
            toast.error(
              "Location permission was not granted. Please allow access to use the recenter feature."
            );
            reject(err);
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      });
      return;
    }

    if (state === "denied") {
      // Browsers will not re-prompt automatically once denied
      toast.info(
        "Location is blocked. Please enable location for this site in your browser settings (Site settings → Location) and try again."
      );
      return;
    }
  } catch {
    // Fallback: try a direct prompt; if it fails, show guidance
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const [lon, lat] = [pos.coords.longitude, pos.coords.latitude];
        map.getView().animate({
          center: [lon, lat],
          zoom: Math.max(map.getView().getZoom() || 7, 14),
          duration: 600,
        });
      },
      () => {
        toast.info(
          "Location is blocked. Please enable location for this site in your browser settings (Site settings → Location) and try again."
        );
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }
}

export {
  add_visualization_layers_to_map,
  add_mouse_click_event,
  get_initial_map,
  get_epsg4326_projection_data_to_source,
  addFeatureLayerToMap,
  removeHighlightLayerFromMap,
  createNewFeatureLayerToMap,
  exitEditMode,
  resetRotation,
  createSinglePolygonEditMode,
  resetDrawingSession,
  toggleSnapGuides,
  getOrCreateUserLocationLayer,
  showUserLocation,
  recenterOnUser,
  requestOrExplainGeolocation,
};
